import { type FC } from 'react'

import { StaticImage } from '../../../image'

import { NfcLandingPageHeroBubble } from './NfcLandingPageHeroBubble'
import hero from './personHoldingInsuranceCard.png'

export const NfcLandingPageHero: FC = () => {
  return (
    <div className="relative hidden h-80 w-full max-w-96 justify-end pr-24 tablet:flex">
      <StaticImage
        alt="a man holding a card and a phone"
        className="object-cover"
        height={320}
        src={hero}
        width={245}
      />
      <NfcLandingPageHeroBubble className="absolute right-0 top-9" />
    </div>
  )
}
